// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

import displayPrice from "../commons/displayPrice";

import DisplayRow from "./DisplayRow";

type RowProps = {
  type: string,
  box: number,
  qty: number,
  price: number,
  onRowChangeQty: (type: string, qty: number) => any
};

const ROW_BORDER = "1px #333 solid";

class Row extends Component<RowProps> {
  onChange = (event: SyntheticEvent<HTMLInputElement>) => {
    let qty = parseInt(event.currentTarget.value, 10);
    if (isNaN(qty) || qty < 0) {
      qty = 0;
    }
    if (qty > 10000) {
      qty = 10000;
    }

    this.props.onRowChangeQty(this.props.type, qty);
  };

  render() {
    const { type, box, qty, price } = this.props;

    const total = qty * price;

    return (
      <DisplayRow
        type={
          <div style={{}}>
            <span>{type}</span>
            <span style={{ marginLeft: 5, fontStyle: "italic", fontSize: 12 }}>
              (par carton de {box})
            </span>
          </div>
        }
        qty={
          <input
            type="number"
            value={qty ? qty : ""}
            onChange={this.onChange}
            style={{
              border: "none",
              textAlign: "right",
              width: "100%"
            }}
          />
        }
        price={<div>{displayPrice(price)}</div>}
        total={<div>{!total ? "" : displayPrice(total)}</div>}
        borders
        style={{
          textAlign: "right",
          borderBottom: ROW_BORDER
        }}
      />
    );
  }
}

type Props = {
  name: string,
  img?: string,
  types: Array<{ type: string, box: number, price: number }>,
  onChangeQty: (name: string, type: string, qty: number) => any,
  itemOrder: { [type: string]: number }
};

class Item extends Component<Props> {
  onRowChangeQty = (type: string, qty: number) => {
    this.props.onChangeQty(this.props.name, type, qty);
  };

  render() {
    const { name, img, types, itemOrder } = this.props;

    return (
      <div
        style={{
          width: "100%",
          borderBottom: "1px #000 solid",
          margin: "0 0 30px 0"
        }}
      >
        <div
          style={{
            textTransform: "uppercase",
            marginBottom: 6,
            fontWeight: "bold"
          }}
        >
          {img ? (
            <Link to={`/bottles/${encodeURIComponent(name)}`}>
              <span title="Cliquer pour plus d'informations">
                <img
                  src="bottle.png"
                  alt="Plus d'informations"
                  style={{ margin: "0 6px", verticalAlign: "sub" }}
                />
                {name}
              </span>
            </Link>
          ) : (
            <span style={{ marginLeft: 20 }}>{name}</span>
          )}
        </div>
        {types.map(({ type, box, price }) => (
          <Row
            key={type}
            type={type}
            box={box}
            qty={itemOrder[type]}
            price={price}
            onRowChangeQty={this.onRowChangeQty}
          />
        ))}
      </div>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/NosBouteilles/Item.js